import React, { memo } from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { Block } from '../../components/core';
import { ReturnsGridHeader } from './returns-grid-header';
import { ReturnsGridContent } from './returns-grid-content';

export const ReturnsGridBlock = memo(function InternalReturnsGridBlock({ id }: { id: string }) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <ReturnsGridHeader id={id} />
      </Block.Header>

      <Block.Content
        id={id}
        errorWrappers={[
          ...COMMON_ERROR_WRAPPERS,
          // MetricsErrorWrapper is last because it requires analysis, so we might as well do all the client-side error checks first
          MetricsErrorWrapper,
        ]}
      >
        <ReturnsGridContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
